


























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
	components: {}
})
export default class PermissionModal extends Vue {
	@Prop({required: true})
	value!: boolean;

	@Prop({required: true})
	title!: string;

	@Prop({required: true})
	body!: string;

	@Prop({default: true})
	showCancel!: boolean;

	@Prop({default: 'Confirm'})
	confirmText!: string;

	@Prop({default: 'Cancel'})
	cancelText!: string;

	cancel() {
		this.$emit('input', false);
		this.$emit('cancel');
	}
}
